// Import statements
import { useAuthState } from 'react-firebase-hooks/auth';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { auth, firestore } from '../firebase';
import toast from 'react-hot-toast';
import { useEffect, useState } from 'react';
import { Flash, Eye, EyeSlash } from 'iconsax-react';
import { useNavigate } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import './login/Login.css';
import { createUserDocument } from '../utils/FirebaseFunctions';

export const Signup = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPass, setConfirmPass] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [user, loading, error] = useAuthState(auth);
  const [APIloading, setAPILoading] = useState(false);
  const [passwordType, setPasswordType] = useState('password');

  const navigate = useNavigate();

  const signIn = () => {
    setAPILoading(true);

    if (email === '' || password === '' || confirmPass === '') {
      toast.error('Please fill all the fields');
      setAPILoading(false); // Reset the loading state
      return;
    }

    if (password !== confirmPass) {
      toast.error('Password and Confirm Password do not match');
      setAPILoading(false); // Reset the loading state
      return;
    }

    createUserWithEmailAndPassword(auth, email, password)
      .then(async (resp) => {
        await addDoc(collection(firestore, 'users'), {
          name,
          uid: resp.user.uid,
          phoneNumber: phone,
          country: 'in',
          email,
          type: 'user',
          createdAt: serverTimestamp(),
        });
        navigate('/');
      })
      .catch((err) => {
        toast.error(err.message.split(':')[1]);
      })
      .finally(() => {
        setAPILoading(false); // Reset the loading state regardless of success or failure
      });
  };

  return (
    <div style={{ overflow: 'hidden' }} className='h-screen w-screen flex flex-col items-center p-5 justify-center'>
      <p className='text-sm font-nunito mb-4 mt-auto'>Welcome !!</p>
      <p className='text-3xl font-nunito flex flex-row gap-[10px] items-center font-medium mb-[50px]'>
        <Flash size='42' color='#0080f3' variant='Bulk' />
        Medisupport
      </p>

      <input
        type='text'
        placeholder='Name'
        value={name}
        onChange={(e) => setName(e.target.value)}
        className='px-5 h-[46px] rounded-sm font-nunito bg-white mb-3 w-[320px]'
      />
      <div className='flex flex-row items-center mb-3 w-[320px] justify-center'>
        <PhoneInput country={'in'} className={'h-[46px] w-full'} value={phone} onChange={setPhone} />
      </div>
      <input
        type='email'
        placeholder='Email'
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className='px-5 h-[46px] rounded-sm font-nunito bg-white mb-3 w-[320px]'
      />
      <div className='flex w-full mb-3 flex-row justify-center items-center'>
        <input
          type={passwordType}
          placeholder='Password'
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className='px-5 ml-[-20px] h-[46px] rounded-sm font-nunito bg-white w-[320px]'
        />
        {passwordType === 'password' && (
          <Eye
            onClick={() => setPasswordType('text')}
            size='22'
            color='#333'
            className='ml-[-40px]'
            variant='TwoTone'
          />
        )}
        {passwordType === 'text' && (
          <EyeSlash
            onClick={() => setPasswordType('password')}
            size='22'
            color='#333'
            className='ml-[-40px]'
            variant='TwoTone'
          />
        )}
      </div>
      <div className='flex w-full mb-3 flex-row justify-center items-center'>
        <input
          type={passwordType}
          placeholder='Confirm Password'
          value={confirmPass}
          onChange={(e) => setConfirmPass(e.target.value)}
          className='px-5 ml-[-20px] h-[46px] rounded-sm font-nunito bg-white w-[320px]'
        />
        {passwordType === 'password' && (
          <Eye
            onClick={() => setPasswordType('text')}
            size='22'
            color='#333'
            className='ml-[-40px]'
            variant='TwoTone'
          />
        )}
        {passwordType === 'text' && (
          <EyeSlash
            onClick={() => setPasswordType('password')}
            size='22'
            color='#333'
            className='ml-[-40px]'
            variant='TwoTone'
          />
        )}
      </div>
      <button
        onClick={signIn}
        disabled={APIloading}
        className={`px-5 h-[46px] rounded-sm bg-blue-500 text-white font-nunito w-[320px] text-center${
          APIloading ? ' opacity-[0.5] cursor-not-allowed' : ' bg-blue-500'
        }`}
      >
        {APIloading ? (
          <div className='flex items-center justify-center'>
            <div className='animate-spin rounded-full h-6 w-6 border-t-2 border-white mr-8'></div>
            Creating Account ...
          </div>
        ) : (
          'Signup'
        )}
      </button>

      <p onClick={() => navigate('/forgotPassword')} className='text-center mt-auto'>Forgot Password</p>
      <p onClick={() => navigate('/login')} className='text-center mt-[20px] mb-[50px]'>
        Already a user ? Login Here
      </p>
    </div>
  );
};
